import React, { PropTypes } from 'react';
import { NitroButtonGroup, NitroButton, NitroPlaceholder, NitroPanel } from 'nitro-components';

import QuoteApprovalHistory from './QuoteApprovalHistory';

const ApprovalActions = (
  {
    approveAction,
    declineAction,
    canApprove,
    canReject,
    workflowSummary,
    totalApprovers,
    currentApprover
  }
) => (
  <NitroPanel>
    <NitroButtonGroup layout="horizontal">
      <NitroButton
        outlined
        variant="failure"
        icon="declined"
        iconVariant="failure"
        label="Decline"
        size="small"
        block
        action={declineAction}
        disabled={!canReject}
      />
      <NitroButton
        outlined
        variant="success"
        icon="success"
        iconVariant="success"
        label="Approve"
        size="small"
        block
        action={approveAction}
        disabled={!canApprove}
      />
    </NitroButtonGroup>
    <NitroPlaceholder size={20} />
    {workflowSummary &&
      <QuoteApprovalHistory
        workflowDetails={workflowSummary}
        totalApprovers={totalApprovers}
        currentApprover={currentApprover}
      />}
  </NitroPanel>
);

ApprovalActions.propTypes = {
  approveAction: PropTypes.func,
  declineAction: PropTypes.func,
  canApprove: PropTypes.bool,
  canReject: PropTypes.bool,
  workflowSummary: PropTypes.array,
  totalApprovers: PropTypes.number,
  currentApprover: PropTypes.number
};

export default ApprovalActions;



// WEBPACK FOOTER //
// ./src/features/corporate-quote/workflow/components/ApprovalActions.js